import cloneDeep from 'lodash/cloneDeep';

import type { Profile } from './profile';
import { initialProfile } from './profile';

export const mapProfile = ({
    ADDRESS,
    CITY,
    COMPANY_NAME,
    confirm_type,
    COUNTRY,
    device_confirmed,
    email,
    NAME,
    name,
    INN,
    KPP,
    OGRN,
    PHONE,
    restricted,
    TYPE,
    USER_ID,
    user_status,
    ZIP,
    userRole,
    userId,
    superadmin,
    superadminUser,
    superadminPermission,
    fromAdmin,
}: any): Profile => ({
    ...cloneDeep(initialProfile),
    id: USER_ID,
    type: TYPE,
    userId: userId,

    restricted,
    userStatus: user_status,
    deviceConfirmed: device_confirmed,
    confirmType: confirm_type,
    name: NAME,
    nikname: name,

    phone: PHONE,
    email,
    userRole,

    companyName: COMPANY_NAME,
    inn: INN || '',
    kpp: KPP || '',
    ogrn: OGRN || '',

    country: COUNTRY,
    zipCode: ZIP,
    city: CITY,
    address: ADDRESS,
    superadmin,
    superadminUser,
    superadminPermission,
    fromAdmin,
});

export const reverseMapProfile = (profile: Profile): any => ({
    USER_TYPE: profile.type,

    NAME: profile.name,
    name: profile.nikname,

    PHONE: profile.phone,

    COMPANY_NAME: profile.companyName,
    INN: profile.inn,
    KPP: profile.kpp,
    OGRN: profile.ogrn,

    COUNTRY: profile.country,
    ZIP: profile.zipCode,
    CITY: profile.city,
    ADDRESS: profile.address,
});
